import { cn } from '../../styles/lib/utils';
import { Badge } from '../Badge';
import { categoryToVariant } from './categoryVariants';

export type CategoryPillProps = {
  /** An arbitrary top-level TOC section label (e.g. "Utilities") — not a fixed taxonomy. */
  category: string;
  className?: string;
  'data-testid'?: string;
};

/**
 * Colored pill for a layer category. Thin wrapper over `Badge` with the
 * category → color mapping from the Layer Library design; labels without a
 * confirmed color render grey.
 */
function CategoryPill({ category, className, 'data-testid': dataTestId }: CategoryPillProps) {
  return (
    <Badge
      color={categoryToVariant(category)}
      className={cn('w-fit', className)}
      data-testid={dataTestId ?? 'category-pill'}
    >
      {category}
    </Badge>
  );
}

export { CategoryPill };
